import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-material-datepicker-demo',
  templateUrl: './material-datepicker-demo.component.html',
  styleUrls: ['./material-datepicker-demo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaterialDatepickerDemoComponent {
  dateFormGroup = new FormGroup({
    date: new FormControl<Date>(new Date()),
    empty: new FormControl<Date>(null),
  });

  constructor() {}
}
